class CardSlider extends HTMLElement {
  constructor() {
    super();

    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    if (this.dataset.inited === "1") return;
    this.dataset.inited = "1";

    this.track = this.querySelector("[data-slider-track]");
    this.slides = this.querySelectorAll("[data-slider-slide]");
    this.prev = this.querySelector("[data-slider-prev]");
    this.next = this.querySelector("[data-slider-next]");
    this.total = this.slides.length;

    this.currentIndex = 0;
    this.isAnimating = false;

    if (!this.track || this.total <= 1) return;

    this.imageIndexMap = new Map();

    this.slides.forEach((slide, i) => {
      const src = slide.dataset.imageSrc;
      if (src) {
        this.imageIndexMap.set(this.normalizeSrc(src), i);
      }
    });

    this.updateArrows(0);

    this.prev?.addEventListener("click", this.onPrev);
    this.next?.addEventListener("click", this.onNext);
    this.track.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize);

    this.card = this.closest("product-card");
    if (!this.card) return;
    this.swatches = this.card.querySelectorAll("[variant-id]");

    this.swatches.forEach((swatch) => {
      swatch.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const imageSrc = swatch.dataset.imageSrc;
          const index = this.imageIndexMap.get(imageSrc);

          if (index !== undefined) {
            this.scrollToIndex(index);
            this.updateArrows(index);
          }
        },
        true,
      );
    });
  }
  normalizeSrc(src) {
    return src.split("?")[0];
  }
  disconnectedCallback() {
    this.prev?.removeEventListener("click", this.onPrev);
    this.next?.removeEventListener("click", this.onNext);
    this.track?.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  getSlideWidth() {
    return this.track.clientWidth;
  }

  getIndex() {
    const w = this.getSlideWidth();
    if (!w) return 0;
    return Math.round(this.track.scrollLeft / w);
  }

  scrollToIndex(index) {
    if (this.isAnimating) return;

    const w = this.getSlideWidth();
    this.isAnimating = true;
    this.currentIndex = index;

    this.track.classList.add("is-scrolling");

    this.track.scrollTo({
      left: index * w,
      behavior: "smooth",
    });
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.track.classList.remove("is-scrolling");
      this.isAnimating = false;
      this.updateArrows(this.getIndex());
    }, 80);
  }

  onPrev(e) {
    e.preventDefault();
    e.stopPropagation();

    const nextIndex = Math.max(0, this.currentIndex - 1);
    this.scrollToIndex(nextIndex);
  }

  onNext(e) {
    e.preventDefault();
    e.stopPropagation();

    const nextIndex = Math.min(this.total - 1, this.currentIndex + 1);
    this.scrollToIndex(nextIndex);
  }

  onScroll() {
    this.track.classList.add("is-scrolling");
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.track.classList.remove("is-scrolling");
      this.isAnimating = false;
      this.updateArrows(this.getIndex());
    }, 80);
  }

  onResize() {
    this.scrollToIndex(this.getIndex());
  }
  updateArrows(index) {
    if (this.prev) {
      this.prev.disabled = index === 0;
      this.prev.classList.toggle("is-disabled", index === 0);
    }

    if (this.next) {
      this.next.disabled = index === this.total - 1;
      this.next.classList.toggle("is-disabled", index === this.total - 1);
    }
  }
}

customElements.define("card-slider", CardSlider);
